import { format } from "date-fns";
import toast from "react-hot-toast";

export const replaceString = (string) => {
  if (string !== undefined && string !== null) {
    return string.replace(/[&\\#,+()$~%_.'":*?<>{}]/g, " ");
  } else {
    return "";
  }
};

export const documentValidator = (file) => {
  if (!file) {
    toast.error("Please upload either pdf or  image file!");
    return false;
  }
  if (!file.name.match(/\.(|pdf|jpg|jpeg|png|gif)$/)) {
    toast.error("Please select a valid image!");
    return false;
  }
  if (file.size > 3000000) {
    toast.error("Image size should be less than 3mb!");
    return false;
  }
  return true;
};

export const imageValidator = (file) => {
  if (!file) {
    toast.error("Please select an image!");
    return false;
  }
  if (!file.name.match(/\.(jpg|jpeg|png|gif)$/)) {
    toast.error("Please select a valid image!");
    return false;
  }
  if (file.size > 3000000) {
    toast.error("Image size should be less than 3mb!");
    return false;
  }
  return true;
};

export const validFigureChecker = (value) => {
  return value === undefined ? 0 : value;
};

export const stringDataCheck = (dataValue, stringNumber) => {
  var response = "*****";
  if (dataValue === undefined || dataValue === null) {
    if (stringNumber === 1) {
      return response;
    }
    for (let i = 1; i < stringNumber; i++) {
      response += " *****";
    }
    return response;
  }
  return dataValue;
};

export const getUserNameAvartar = (word) => {
  var newWords = word.split(" ");
  var string1 = newWords[0];
  var string2 = newWords[1];

  return getDoubleInitials(string1, string2);
};

export const getDoubleInitials = (string1, string2) => {
  if (string1 !== undefined && string2 !== undefined) {
    return (
      string1.charAt(0).toUpperCase() + "" + string2.charAt(0).toUpperCase()
    );
  } else if (string1 !== undefined && string2 === undefined) {
    return string1.charAt(0).toUpperCase();
  } else {
    return "";
  }
};

export const capitalizeWord = (string1) => {
  if (string1 !== undefined) {
    return string1.charAt(0).toUpperCase() + string1.slice(1).toLowerCase();
  } else {
    return "";
  }
};

export const getSingleInitials = (string1) => {
  if (string1 !== undefined) {
    return string1.charAt(0).toUpperCase();
  } else {
    return "";
  }
};

export const timeFormatterUI = (date) => {
  const newDate = new Date(date);
  return format(newDate, "hh:mm a");
};

export const dateFormatterUI = (eventDate) => {
  const newYears = new Date(eventDate);
  const formattedDate = format(newYears, "EEEE MMMM d hh:mm a");

  return formattedDate;
};

export const dateFormatterUI2 = (eventDate) => {
  const newYears = new Date(eventDate);
  const formattedDate = format(newYears, "EE d/MM/yyyy hh:mm a");

  return formattedDate;
};

export const dateFormatterUI3 = (eventDate) => {
  console.log({ eventDate });
  if (eventDate !== undefined) {
    const newYears = new Date(eventDate);
    const formattedDate = format(newYears, "EEEE MMMM d yyyy hh:mm a");
    return formattedDate;
  }
  return eventDate;
};

export const dateFormatterUI4 = (eventDate) => {
  if (eventDate !== undefined) {
    const newYears = new Date(eventDate);
    const formattedDate = format(newYears, "MMMM d, yyyy hh:mm a");

    return formattedDate;
  }
  return eventDate;
};

export const dateFormatterUI5 = (eventDate) => {
  if (eventDate !== undefined) {
    const newYears = new Date(eventDate);
    const formattedDate = format(newYears, "d/MM/yyyy hh:mm");

    return formattedDate;
  }
  return eventDate;
};

export const dateFormatterUI6 = (eventDate) => {
  if (eventDate !== undefined) {
    const newYears = new Date(eventDate);
    const formattedDate = format(newYears, "EE, d MMM yyyy hh:mm a");
    return formattedDate;
  }
  return eventDate;
};

export const dateCartFormatter = (date) => {
  const year = new Date(date);
  const formattedDate = format(year, "d MMMM yyyy");

  return formattedDate;
};

export const modifyList = (itemList, id, key, statusKey) => {
  return itemList.map((item) => {
    if (item[key] === id) {
      item[statusKey] = !item[statusKey];
      return item;
    }
    return item;
  });
};

export const deleteItemHelper = (list, id, idKey) => {
  return list.filter((item) => item[idKey] !== id);
};

export const filterData = (data, filterValue, keys) => {
  if (filterValue === "" || filterValue === "ALL") {
    return data;
  }
  if (filterValue !== null || filterValue !== undefined) {
    const filter = filterValue.toLowerCase();
    return data.filter((item) =>
      keys.some((keyItem) => item[keyItem].toLowerCase().indexOf(filter) !== -1)
    );
  } else {
    return "";
  }
};

export const stringSorter = (a, b) => {
  let a2 = "",
    b2 = "" || 0;
  if (a) {
    a2 = a;
  }
  if (b) {
    b2 = b;
  }
  return a2.localeCompare(b2);
};
